import { css, theme } from '../lib';
import { media } from '../utils/media-queries';

import { baseFontHeading } from './text';

export const h1 = css`
  ${baseFontHeading}
  font-size: ${theme.headingFontSizes['3xl']};
  line-height: ${theme.lineHeights.shorter};

  ${media.min('l')`
    font-size: ${theme.headingFontSizes['4xl']};
  `}
`;

export const h2 = css`
  ${baseFontHeading}
  font-size: ${theme.headingFontSizes.xl};
  line-height: ${theme.lineHeights.shorter};

  ${media.min('l')`
    font-size: ${theme.headingFontSizes['2xl']};
  `}
`;

export const h3 = css`
  ${baseFontHeading}
  font-size: ${theme.headingFontSizes.m};
  line-height: ${theme.lineHeights.shorter};

  ${media.min('l')`
    font-size: ${theme.headingFontSizes.l};
  `}
`;

export const h4 = css`
  ${baseFontHeading}
  font-size: ${theme.headingFontSizes.s};
  line-height: ${theme.lineHeights.shorter};

  ${media.min('l')`
    font-size: ${theme.headingFontSizes.m};
  `}
`;
export const h5 = css`
  ${baseFontHeading}
  font-size: ${theme.headingFontSizes.xs};
  line-height: ${theme.lineHeights.shorter};

  ${media.min('l')`
    font-size: ${theme.headingFontSizes.s};
  `}
`;

export const h6 = css`
  font-size: ${theme.headingFontSizes.xxs};
  line-height: ${theme.lineHeights.shorter};
  font-family: ${theme.fonts.secondary};

  ${media.min('l')`
    font-size: ${theme.headingFontSizes.xs};
  `}
`;
